import { render, staticRenderFns } from "./addMdfe.vue?vue&type=template&id=5b3fb588&scoped=true"
import script from "./addMdfe.vue?vue&type=script&lang=js"
export * from "./addMdfe.vue?vue&type=script&lang=js"
import style0 from "./addMdfe.vue?vue&type=style&index=0&id=5b3fb588&scoped=true&lang=css"
import style1 from "./addMdfe.vue?vue&type=style&index=1&id=5b3fb588&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3fb588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b3fb588')) {
      api.createRecord('5b3fb588', component.options)
    } else {
      api.reload('5b3fb588', component.options)
    }
    module.hot.accept("./addMdfe.vue?vue&type=template&id=5b3fb588&scoped=true", function () {
      api.rerender('5b3fb588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/invoiceCenter/mdfe/cmp/addMdfe.vue"
export default component.exports